import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { FavouriteTransfersState, FavouriteTransfersActionTypes } from './types';
import { defaultState } from './defaultState';

const FavouriteTransfersContext = createContext<Partial<FavouriteTransfersState>>(defaultState);
const FavouriteTransfersDispatchContext = createContext<
  Dispatch<PayloadAction<FavouriteTransfersActionTypes, any>> | undefined
>(undefined);

export { FavouriteTransfersContext, FavouriteTransfersDispatchContext };
